import { ChainID } from '@ankr.com/chains-list';

/**
 * Returns a valid `ChainID` if the provided `chainId` string matches one of the defined `ChainID` values.
 *
 * @param chainId - The chain ID as a string to validate.
 * @returns The corresponding `ChainID` if valid, otherwise `ChainID.UNDEFINED`.
 */
export function getValidChainId(chainId?: string): ChainID {
  if (Object.values(ChainID).includes(chainId as ChainID)) {
    return chainId as ChainID;
  }

  return ChainID.UNDEFINED;
}
